import { useEffect, useState } from 'react';

/**
 * Returns `true` once the window has been scrolled past `threshold` pixels.
 * Used by Nav to apply an elevated shadow once the user starts scrolling.
 */
export function useScrolled(threshold = 40): boolean {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
}
